// Centralised brand assets – provided by client
export const ASSETS = {
  videos: {
    loopHero: "/media/loop-hero.mp4",
    speakFarum: "/media/speak-farum.mp4",
  },
  images: {
    teamGroup:
      "https://customer-assets.emergentagent.com/job_eda5de61-7412-4813-8c24-01117e9f4a36/artifacts/v52fsjd9_gruppe%20billede.jpg",
    industrialPipes: "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/pd8amw8o_fa_2.2.1.jpg&w=2000&output=webp&q=80",
    architecture: "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/uoawvm8i_fa_4.3.1.jpg&w=2000&output=webp&q=80",
    // Service moods (alle grabs fra klient)
    rats: "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/r6wqgnwv_fa_1.11.1.jpg&w=2000&output=webp&q=80",
    pipes: "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/a53nyuk4_fa_4.14.1.jpg&w=2000&output=webp&q=80",
    contract: "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/hrla2ua7_fa_3.6.1.jpg&w=2000&output=webp&q=80",
    noDig: "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/b7wtdnf3_fa_1.38.1.jpg&w=2000&output=webp&q=80",
    flush: "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/5fi00g8l_fa_5.4.1.jpg&w=2000&output=webp&q=80",
    insurance: "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/2trehy0e_fa_4.7.1.jpg&w=2000&output=webp&q=80",
    contractor: "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/eqt6auzu_fa_5.3.1.jpg&w=2000&output=webp&q=80",
    utility: "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/3qx7pjce_fa_2.5.1.jpg&w=2000&output=webp&q=80",
    caseSite1: "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/ikb6tiyi_fa_1.2.1.jpg&w=2000&output=webp&q=80",
    caseSite2: "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/abihfe1s_fa_1.33.1.jpg&w=2000&output=webp&q=80",
    caseSite3: "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/tburh6wo_fa_1.56.1.jpg&w=2000&output=webp&q=80",
  },
  staff: [
    {
      id: "s1",
      name: "Christoffer Kiertner",
      role: "Virksomhedsejer",
      credentials: ["Aut. Kloakmester", "Cert. rottefænger", "Aut. VVS-installatør"],
      photo:
        "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/ugeoho8g_DSC08763.jpg&w=800&h=1067&fit=cover&output=webp&q=82",
    },
    {
      id: "s2",
      name: "Mads Munkholm",
      role: "Rørlægger",
      photo:
        "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/5xuxo90l_DSC08526%25201.jpg&w=800&h=1067&fit=cover&output=webp&q=82",
    },
    {
      id: "s3",
      name: "Marius Andersen",
      role: "Rørlægger",
      photo:
        "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/6vhn2bxx_DSC08585%25201.jpg&w=800&h=1067&fit=cover&output=webp&q=82",
    },
    {
      id: "s4",
      name: "Nicklas Bergholdt",
      role: "Rørlægger",
      photo:
        "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/8gf45m24_DSC08637.jpg&w=800&h=1067&fit=cover&output=webp&q=82",
    },
    {
      id: "s5",
      name: "Dimitri Degner",
      role: "Rørlægger",
      photo:
        "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/6ydo7d88_DSC08808.jpg&w=800&h=1067&fit=cover&output=webp&q=82",
    },
    {
      id: "s6",
      name: "Iben Kiertner",
      role: "Kontorassistent",
      photo:
        "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/uksdnyyy_DSC08543%25201.jpg&w=800&h=1067&fit=cover&output=webp&q=82",
    },
    {
      id: "s7",
      name: "Camilla Gudmandsen",
      role: "Kontor­ansvarlig",
      photo:
        "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/c7ug9o89_DSC08675.jpg&w=800&h=1067&fit=cover&output=webp&q=82",
    },
  ],
  grabs: {
    excavation:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/ikb6tiyi_fa_1.2.1.jpg&w=2000&output=webp&q=80",
    machinery:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/xkuxdt7n_fa_1.9.1.jpg&w=2000&output=webp&q=80",
    tank:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/js1418c7_fa_1.10.1.jpg&w=2000&output=webp&q=80",
    digHole:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/r6wqgnwv_fa_1.11.1.jpg&w=2000&output=webp&q=80",
    van:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/7gr4rf89_fa_1.23.1.jpg&w=2000&output=webp&q=80",
    pipesStack:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/abihfe1s_fa_1.33.1.jpg&w=2000&output=webp&q=80",
    pipeInstall:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/b7wtdnf3_fa_1.38.1.jpg&w=2000&output=webp&q=80",
    pipeDetail:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/ols0gdre_fa_1.39.1.jpg&w=2000&output=webp&q=80",
    vanInterior:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/tburh6wo_fa_1.56.1.jpg&w=2000&output=webp&q=80",
    toolCloseup:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/ql1yveve_fa_1.59.1.jpg&w=2000&output=webp&q=80",
    excavatorTrack:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/bhtdsjfb_fa_2.1.1.jpg&w=2000&output=webp&q=80",
    aerialBase:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/pd8amw8o_fa_2.2.1.jpg&w=2000&output=webp&q=80",
    tvInspection:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/f6624urj_fa_2.3.1.jpg&w=2000&output=webp&q=80",
    pipeInHole:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/gzrevmg1_fa_2.4.1.jpg&w=2000&output=webp&q=80",
    tankInstall:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/3qx7pjce_fa_2.5.1.jpg&w=2000&output=webp&q=80",
    teamAtBase:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/k3e5ge9p_fa_2.6.1.jpg&w=2000&output=webp&q=80",
    smilingCrew:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/wtio3m2q_fa_3.1.1.jpg&w=2000&output=webp&q=80",
    weatherVane:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/bi7y7vuy_fa_3.2.1.jpg&w=2000&output=webp&q=80",
    portraitConversation:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/j1xssqhk_fa_3.3.1.jpg&w=2000&output=webp&q=80",
    vanBranded:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/fj9fnwg7_fa_3.4.1.jpg&w=2000&output=webp&q=80",
    workshop:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/hrla2ua7_fa_3.6.1.jpg&w=2000&output=webp&q=80",
    crewLaughing:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/mpq45u7g_fa_3.13.1.jpg&w=2000&output=webp&q=80",
    twoMenWell:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/h9jf1xkg_fa_3.14.1.jpg&w=2000&output=webp&q=80",
    overheadTrench:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/a67d8b7i_fa_4.1.1.jpg&w=2000&output=webp&q=80",
    fleetAtBase:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/uoawvm8i_fa_4.3.1.jpg&w=2000&output=webp&q=80",
    tvInspectionField:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/tkx18hd6_fa_4.6.1.jpg&w=2000&output=webp&q=80",
    laptopVan:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/2trehy0e_fa_4.7.1.jpg&w=2000&output=webp&q=80",
    portraitFlag:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/oygwprd8_fa_4.11.1.jpg&w=2000&output=webp&q=80",
    largePipeInstall:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/a53nyuk4_fa_4.14.1.jpg&w=2000&output=webp&q=80",
    carryingPipe:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/u3h7a9f1_fa_5.1.1.jpg&w=2000&output=webp&q=80",
    brandedConsult:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/eqt6auzu_fa_5.3.1.jpg&w=2000&output=webp&q=80",
    tvScreen:
      "https://wsrv.nl/?url=https://customer-assets.emergentagent.com/job_kloak-evolve/artifacts/5fi00g8l_fa_5.4.1.jpg&w=2000&output=webp&q=80",
  },
  brand: {
    phone: "44 48 06 16",
    phoneTel: "tel:+4544480616",
    booking: "https://clearbook.dk/booking/farumkloak/",
    email: "info@farumkloak.dk",
    address: "Nordsjælland & Storkøbenhavn",
  },
};
